// extracted by mini-css-extract-plugin
module.exports = {"btn":"_5nAVzHqITRGlNf3usDpkp","icon":"wfE3VvHgrd65jfiTUh1ZX"};